import React, { Component } from 'react';
import { WithStyles, withStyles } from '@mui/styles';
import { withTranslate } from '../../../core/TenantProvider';
import APAddressDetailsStyles from './styles/APAddressDetails.style';
import APHeading from '../../atoms/APHeading';
import APInput from '../../atoms/APInput';
import APButton from '../../atoms/APButton';
import APSelect from '../../atoms/APSelect';
import { addressCountryMapping } from '../../../containers/SettingsContainer/utils/getters';
import { InitialSettingValues } from '../../../containers/SettingsContainer/SettingsContainer';
import _ from 'lodash';
import { ADDRESS_DETAILS_FORM } from './definitions/addressDetails';
import { USA_COUNTRY_LABEL } from '../../../core/utils/Constants/Constants';

interface APAddressDetailsProps extends WithStyles<typeof APAddressDetailsStyles> {
    translate: Function,
    values: InitialSettingValues | undefined,
    handleChange: Function,
    formRef: React.RefObject<any>,
    errors: InitialSettingValues,
    editAddress: boolean,
    onEditAddress: Function,
    setFieldValue: Function
}

interface APAddressDetailsState {
    editAddress: boolean,
    isEditLinkClicked: boolean,
}

class APAddressDetails extends Component<APAddressDetailsProps, APAddressDetailsState> {

    constructor(props: any) {
        super(props)
        this.state = {
            editAddress: false,
            isEditLinkClicked: false,
        }

        this.onEditAddress = this.onEditAddress.bind(this);
        this.onChange = this.onChange.bind(this);
    }

    componentDidMount(): void {
        this.setState({
            editAddress: this.props.editAddress
        });
    }

    componentDidUpdate(prevProps: Readonly<APAddressDetailsProps>): void {
        !(_.isEqual(prevProps.editAddress, this.props.editAddress)) &&
            this.setState({
                editAddress: this.props.editAddress
            });
    }

    onEditAddress() {
        this.setState({
            editAddress: true,
            isEditLinkClicked: true,
        }, () => {
            if (this.props.onEditAddress) {
                this.props.onEditAddress(true)
            }
        });
    }

    onChange(event: React.ChangeEvent<any>) {
        const {
            values,
            handleChange,
            setFieldValue
        } = this.props;

        if (values?.address?.state !== '' && !USA_COUNTRY_LABEL.includes(values?.address?.country as string)) {
            if (values) {
                setFieldValue('address.state', '');
            }
        }

        event.target.value = event.target.value.trimStart();

        if (handleChange) {
            handleChange(event)
        }
    }

    render() {
        const {
            classes,
            translate,
            values,
            errors
        } = this.props;

        const {
            editAddress
        } = this.state;

        const addressSummaryItemValue: string = `${values?.address?.city + ' ' || ''}
                                                ${values?.address?.state + ' ' || ''}
                                                ${((values?.address?.city?.length ?? 0) ||
                (values?.address?.state?.length ?? 0)) > 0 ? ', ' : ''} 
                                                ${values?.address?.postCode || ''}`

        return (
            <>
                <div className={classes.formSectionHeader}>
                    <APHeading className={classes.formSectionHeading}
                        variant="body1">
                        {translate(ADDRESS_DETAILS_FORM.label)}
                    </APHeading>
                </div>
                {editAddress &&
                    <div className={classes.formSectionContent}>
                        {ADDRESS_DETAILS_FORM.fields.map((field) => {
                            const isUSACountryCheck: boolean = USA_COUNTRY_LABEL.includes(values?.address.country as string);
                            const shouldFieldShow: boolean = field?.isCountryUSA ? isUSACountryCheck : true;

                            if (field.component === 'text') {
                                return (shouldFieldShow &&
                                    <APInput
                                        key={field.value}
                                        label={translate(field.label)}
                                        name={field.name}
                                        value={values?.address?.[field.value]}
                                        className={classes.formSectionInput}
                                        onChange={this.onChange}
                                        error={Boolean(errors?.address?.[field.value])}
                                        helperText={errors?.address?.[field.value]}
                                        isCoralogixMasked={true}
                                    />
                                );
                            }
                            if (field.component === 'select') {
                                return (
                                    <APSelect
                                        key={field.value}
                                        className={classes.formSectionInput}
                                        label={translate(field.label)}
                                        name={field.name}
                                        onChange={this.onChange}
                                        type="country"
                                        value={addressCountryMapping(values?.address?.[field.value])}
                                        error={Boolean(errors?.address?.[field.value])}
                                        helperText={errors?.address?.[field.value]}
                                        hasErrorState={true}
                                    />
                                );
                            }
                            return null
                        })}
                    </div>
                }

                {!editAddress &&
                    <div className={classes.formSectionContent}>
                        <div className={classes.summaryContent}>
                            <div className={classes.summaryItem}>
                                <span className={classes.summaryItemValue}>{values?.address?.addressLineNo1}</span>
                                <span className={classes.summaryItemValue}>
                                    {addressSummaryItemValue}
                                </span>
                                <span className={classes.summaryItemValue}>
                                    {values?.image && <img src={values?.image} className={classes.itemIcon} alt={values.addressCountryName} />}
                                    {values?.addressCountryName}
                                </span>
                                <APButton
                                    className={classes.editAddressLink}
                                    onClick={this.onEditAddress}
                                    data-testid='edit-address-link'
                                    variant="text"
                                    color="primary">
                                    {translate('settings.address.editaddress.label')}
                                </APButton>
                            </div>
                        </div>
                    </div>
                }
            </>
        )
    }
}

export default withTranslate(
    withStyles(APAddressDetailsStyles)(APAddressDetails)
);